import { IonCard, IonCardContent } from '@ionic/react';
import { useEffect, useState } from 'react';

import SlideContent from '../../../components/slide-content/SlideContent';
import Aid from './Online/Aid';
import Pay from './Online/Pay';

interface Props {
    auth: boolean,
    obligation?: any,
    amount?: any
}

const Online: React.FC<Props> = (props) => {
    return <SlideContent type="segment">
        <IonCard>
            <IonCardContent>
                {props.auth ? 
                <Aid amount={props.amount} obligation={props.obligation} />
                : <Pay />}
            </IonCardContent>
        </IonCard>
    </SlideContent>
};

export default Online